import {Typography} from '@mui/material';
import {FC, useEffect, useState} from 'react';
import AdminSmallBlock from './AdminSmallBlock';
import AdminDiagram from './AdminDiagram';
import LastTransactions from './Last transactions';
import {getErrorMessage} from '@/utils/helpers';
import {toast} from 'react-toastify';
import {useAppDispatch, useAppSelector} from '@/store/hooks';
import {StatisticTerm} from '@/utils/enums';
import {
  getAdminStatistic,
  getAllOrganizationsTransactions,
  getStatisticSelector,
  getTransactionsListSelector,
} from '@/store/admin';

const AdminDashboard: FC = () => {
  const dispatch = useAppDispatch();

  const [statisticsTerm, setStatisticsTerm] = useState(StatisticTerm.MONTHLY);
  const statistic = useAppSelector(getStatisticSelector);
  const transactionData = useAppSelector(getTransactionsListSelector);

  const getStatisticData = async () => {
    try {
      const data = {
        page: 1,
        pageSize: 6,
      };

      await dispatch(getAdminStatistic(statisticsTerm)).unwrap();
      await dispatch(getAllOrganizationsTransactions(data)).unwrap();
    } catch (error) {
      toast.error(getErrorMessage(error));
    }
  };

  useEffect(() => {
    getStatisticData();
  }, [statisticsTerm]);

  return (
    <>
      <AdminSmallBlock statistics={statistic} />
      <AdminDiagram
        diagramData={statistic?.incomes || []}
        setStatisticsTerm={setStatisticsTerm}
        statisticsTerm={statisticsTerm}
      />
      {transactionData?.data ? (
        <LastTransactions transactions={transactionData?.data} />
      ) : (
        <Typography>No transactions</Typography>
      )}
    </>
  );
};

export default AdminDashboard;
